import { Box, SegmentedToggle } from "@wix/design-system";
import { CodeSmall, LinkSmall } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context";
import { LinkInput } from "./../../../ui-components";
import { EDIT_PANEL_SEGMENTED_TOGGLE, EDIT_PANEL_URL_INPUT } from "../../data-hooks";
import { HtmlInputArea } from "./HtmlInputArea";
const INPUT_HTML = "html";
const INPUT_URL = "url";
const HtmlSourceInput = ({
  htmlNodeAttrs,
  onHtmlInputChange,
  onLinkInputChange,
  inputRef
}) => {
  const { t } = useContext(RicosContext);
  const [inputType, setInputType] = useState(
    htmlNodeAttrs?.url ? INPUT_URL : INPUT_HTML
  );
  const onInputToggleClick = (_, value) => {
    inputType !== value && setInputType(value);
  };
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3" }, /* @__PURE__ */ React.createElement(
    SegmentedToggle,
    {
      defaultSelected: inputType,
      size: "small",
      onClick: onInputToggleClick,
      dataHook: EDIT_PANEL_SEGMENTED_TOGGLE
    },
    /* @__PURE__ */ React.createElement(SegmentedToggle.Button, { value: INPUT_HTML, prefixIcon: /* @__PURE__ */ React.createElement(CodeSmall, null) }, t("HtmlEditPanel_Code")),
    /* @__PURE__ */ React.createElement(SegmentedToggle.Button, { value: INPUT_URL, prefixIcon: /* @__PURE__ */ React.createElement(LinkSmall, null) }, t("HtmlEditPanel_Source"))
  ), inputType === INPUT_HTML ? /* @__PURE__ */ React.createElement(
    HtmlInputArea,
    {
      placeholder: t("HtmlEditPanel_HtmlInput_Placeholder"),
      value: htmlNodeAttrs?.html ?? "",
      onChange: (value) => {
        onHtmlInputChange?.(value);
      }
    }
  ) : /* @__PURE__ */ React.createElement(
    LinkInput,
    {
      value: htmlNodeAttrs?.url ?? "",
      placeholder: t("HtmlEditPanel_UrlInput_Placeholder"),
      size: "small",
      labelEnabled: false,
      dataHook: EDIT_PANEL_URL_INPUT,
      inputRef,
      onChange: (url) => {
        onLinkInputChange?.(url ?? "");
      }
    }
  ));
};
export {
  HtmlSourceInput
};
//# sourceMappingURL=HtmlSourceInput.js.map
